import { render } from "./AdminTickets.vue?vue&type=template&id=db7b0b94"
import script from "./AdminTickets.vue?vue&type=script&lang=js"
export * from "./AdminTickets.vue?vue&type=script&lang=js"
script.render = render

export default script